import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface unresponsiveDialogData {
  title?: string;
  description?: string;
  closeText?: string;
}

@Component({
  selector: 'app-unresponsive-dialog',
  templateUrl: './unresponsive-dialog.component.html',
  styleUrls: ['./unresponsive-dialog.component.scss']
})
export class UnresponsiveDialogComponent {

  title: string = '';
  description: string = '';
  closeText = 'Cerrar';
  mobileQuery: MediaQueryList;
  constructor(
    public dialogRef: MatDialogRef<UnresponsiveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: unresponsiveDialogData,
    media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef) {
    if (data.title) {
      this.title = data.title;
    }
    if (data.description) {
      this.description = data.description
    }
    if (data.closeText) {
      this.closeText = data.closeText
    }
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);
  }

  ngOnInit() {
  }

  private mobileQueryListener: () => void;

}
